export default __webpack_public_path__ + "static/media/error404.05b2d1f5.png";